<template>
  <div>
    <v-row noGutters>
      <BaseSidebar />
    </v-row>
    <v-container>
      <v-row>
        <v-col
          class="pt-0"
          cols="12"
          md="4"
        >
          <v-row>
            <v-col
              class="pt-0"
              cols="12"
            >
              <Appointments />
            </v-col>
          </v-row>
        </v-col>
        <v-col
          class="pt-0"
          cols="12"
          md="8"
        >
          <v-row>
            <v-col
              cols="12"
              lg="7"
              class="pt-0"
            >
              <h3 class="headline text-center">
                {{ $t('dashboard.workToComplete.title') }}
              </h3>
              <v-progress-linear
                v-if="loading"
                indeterminate
              />
              <div
                v-else-if="workTodo.length > 0"
                class="work-list"
              >
                <v-row noGutters>
                  <v-col
                    v-for="work in workTodo"
                    :key="work.id"
                    cols="6"
                  >
                    <WorkToDo
                      class="m-1"
                      :work="work"
                    />
                  </v-col>
                </v-row>
              </div>
              <EmptyState
                v-else
                icon="check_circle"
                :label="$t('dashboard.workToComplete.noData')"
              />
            </v-col>
            <v-col
              class="pt-0"
              cols="12"
              lg="5"
            >
              <h3 class="headline text-center">
                {{ $t('dashboard.alerts.title') }}
              </h3>
              <v-progress-linear
                v-if="loading"
                indeterminate
              />
              <v-sheet v-else-if="alerts.length > 0">
                <Alerts
                  v-for="(alert,idx) in alerts"
                  :key="idx"
                  :alert="alert"
                />
              </v-sheet>
              <EmptyState
                v-else
                icon="notification_important"
                :label="$t('dashboard.alerts.noData')"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="7"
              class="pt-0"
            >
              <h3 class="headline text-center">
                {{ $t('dashboard.labProgress.title') }}
              </h3>
              <v-progress-linear
                v-if="loading"
                indeterminate
              />
              <div
                v-else-if="labAnalysis.length > 0"
                class="labAnalysis vertical-blurred-scroll"
              >
                <LabAnalysis
                  v-for="analysis in labAnalysis"
                  :key="analysis.id"
                  :analysis="analysis"
                />
              </div>
              <EmptyState
                v-else
                icon="search"
                :label="$t('dashboard.labProgress.noData')"
              />
            </v-col>
            <v-col
              cols="5"
              class="pt-0"
            >
              <h3 class="md-headline text-center">
                {{ $t('dashboard.reports.title') }}
              </h3>
              <v-progress-linear
                v-if="loading"
                indeterminate
              />
              <div
                v-else-if="reports.length > 0"
                class="recent-reports vertical-blurred-scroll"
              >
                <RecentReports
                  v-for="report in reports"
                  :key="report.id"
                  cols="6"
                  class="mb-2"
                  :report="report"
                />
              </div>
              <EmptyState
                v-else
                icon="insert_drive_file"
                :label="$t('dashboard.reports.noData')"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import LabAnalysis from '@/components/dashboard/LabAnalysis.vue';
import Alerts from '@/components/dashboard/DashboardAlerts.vue';
import Appointments from '@/components/dashboard/Appointments.vue';
import WorkToDo from '@/components/dashboard/WorkToComplete.vue';
import RecentReports from '@/components/dashboard/RecentReports.vue';
import EmptyState from '@/components/shared/widgets/EmptyState.vue';
import BaseSidebar from '@/components/shared/navigation/BaseSidebar.vue';


export default {
    components: {
        LabAnalysis,
        Alerts,
        Appointments,
        WorkToDo,
        RecentReports,
        EmptyState,
        BaseSidebar,
    },
    data() {
        return {
            workTodo: [{
                title: 'incompleteVisits',
            },
            {
                title: 'reportsToApprove',
            },
            {
                title: 'appointments',
            },
            {
                title: 'samples',
            },
            {
                title: 'contractToRenew',
            },
            {
                title: 'legionela',
            }],
            alerts: [],
            labAnalysis: [],
            reports: [],
            loading: false,
        };
    },
    computed: {
        ...mapGetters(['teamID']),
    },
    created() {
        // to set the team store attribute
        this.reloadTeam(this.teamID);
    },
    methods: {
        ...mapActions({ reloadTeam: 'reloadTeam' }),
    },
};
</script>

<style lang="scss" scoped>
  .labAnalysis {
    height: 376px;
  }
  .recent-reports {
    height: 376px;
  }
</style>
